import { z } from 'zod'

export const RegionAlternativeServiceZod = z.object({
  companyName: z.string(),
  phoneNumber: z.string(),
})

export type RegionOpeningHours = z.infer<typeof RegionOpeningHoursZod>
export const RegionOpeningHoursZod = z.object({
  from: z.string(),
  to: z.string(),
})

export type RegionWeekOpeningHours = z.infer<typeof RegionWeekOpeningHoursZod>
export const RegionWeekOpeningHoursZod = z.object({
  sunday: RegionOpeningHoursZod.nullable(),
  monday: RegionOpeningHoursZod.nullable(),
  tuesday: RegionOpeningHoursZod.nullable(),
  wednesday: RegionOpeningHoursZod.nullable(),
  thursday: RegionOpeningHoursZod.nullable(),
  friday: RegionOpeningHoursZod.nullable(),
  saturday: RegionOpeningHoursZod.nullable(),
})

export const RegionDonationInformationZod = z.object({
  link_fr: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  link_en: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  organization: z.string(),
})

export const RegionRegistrationInformationZod = z.object({
  en: z.string(),
  fr: z.string(),
})

export const RegionHeadquarterZod = z.object({
  name: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  civicNumber: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  address: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  city: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  state: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  zip: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  openingHours: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  notes: z
    .string()
    .nullable()
    .transform((value) => value ?? ''),
  id: z.string(),
})

export type RegionInfo = z.infer<typeof RegionInfoZod>
export const RegionInfoZod = z.object({
  id: z.string(),
  active: z.boolean().optional().default(false),
  organizationName: z.string(),
  customerPhoneNumber: z.string(),
  volunteerPhoneNumber: z.string(),
  alternativeServices: z.array(RegionAlternativeServiceZod),
  cities: z.array(z.string()),
  province: z.string(),
  emailAddress: z.string(),
  operationDates: z.array(z.string()),
  openingHours: RegionWeekOpeningHoursZod,
  donationInformation: RegionDonationInformationZod.nullable(),
  headquarters: z.array(RegionHeadquarterZod),
  registrationInformation: RegionRegistrationInformationZod,
})
